import React, { useCallback, useEffect, useRef, useState } from "react";
import "./SelectSongBook.scss";
import {
  IoEnter,
  IoSearchOutline,
  IoCloseCircleOutline
} from "react-icons/io5";
import RestClient from "../../../@core/restClient";
import { listenerCancelled } from "@reduxjs/toolkit/dist/listenerMiddleware/exceptions";
import debounce from "lodash/debounce";
import { Songbook } from "../../../@core/models";
import Spinner from "../UI/Spinner";

const SelectSongBook = (props: any) => {
  const [songBookList, setSongBookList]: any = useState([]);
  const [selectVisible, setSelectVisible]: any = useState("");
  const [inputValue, setInputValue]: any = useState("");
  // const [inputValue, setInputValue]: any = useState(
  //   localStorage.getItem("songbook") || ""
  // );
  const [bookId, setBookId]: any = useState(null);
  // const [bookId, setBookId]: any = useState(
  //   Number(localStorage.getItem("songbookId")) || null
  // );
  const [isLoading, setIsLoading] = useState(false);
  const bookRef = useRef<any>();

  useEffect(() => {
    const localBookId = localStorage.getItem("songbookId");
    const user = JSON.parse(localStorage.getItem("User") || "{}")?.id || "";
    if (localBookId) {
      (async () => {
        try {
          const book = await RestClient.getSongbook(localBookId);
          if (
            (book && user === book.ownerId) ||
            (book && book.collaborators.includes(user))
          ) {
            setBookId(localBookId);
            setInputValue(book.title);
          } else {
            return;
          }
        } catch (error) {
          console.log(error);
        }
      })();
    } else {
      return;
    }
  }, []);

  const deferredSetQueryHandler = useCallback(
    debounce((event: React.ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value);
    }, 500),
    []
  );

  useEffect(
    function () {
      (async () => {
        if (
          bookRef.current !== document.activeElement ||
          bookRef.current.value !== inputValue
        ) {
          return;
        }
        try {
          //setIsLoading(true);
          const list = await RestClient.getSongbookList(inputValue);
          setSongBookList(list || []);
          setSelectVisible("visable");
        } catch (error) {
          console.log(error);
        }
        //setIsLoading(false);
      })();
    },
    [inputValue, selectVisible]
  );

  const selectSongbook = (songbook: Songbook) => {
    bookRef.current.value = songbook.title;
    setInputValue(songbook.title);
    setBookId(songbook.id);
    localStorage.setItem("songbookId", String(songbook.id));
    localStorage.setItem("songbook", String(songbook.title));
    setSelectVisible("");
  };

  useEffect(() => {
    props.passBookId(bookId);
  }, [bookId]);

  const clear = (e: any) => {
    e.stopPropagation();
    setSelectVisible("visable");
    setInputValue("");
    bookRef.current.value = "";
  };
  useEffect(() => {
    if (selectVisible) {
      document.body.addEventListener("click", () => {
        setSelectVisible(false);
      });
    } else {
      return;
    }
  }, [selectVisible]);

  return (
    <div className="select">
      {isLoading ? <Spinner /> : ""}
      <input
        className="select-input"
        defaultValue={inputValue}
        onClick={(e) => clear(e)}
        ref={bookRef}
        onChange={deferredSetQueryHandler}
      />
      <div className={selectVisible || "select-box"}>
        {songBookList.map((book: any) => (
          <div
            key={book.id}
            className="select-box-item"
            onClick={() => selectSongbook(book)}
          >
            {book.title}
          </div>
        ))}
        {/* <IoCloseCircleOutline
          className="select-close"
          onClick={() => setSelectVisible("")}
        /> */}
      </div>

      <IoSearchOutline className="select-search" />
    </div>
  );
};

export default SelectSongBook;
